import { makeVar } from '@apollo/client'

export const planDetailsDialogVisibleVar = makeVar<boolean>(false)
